import Vue from "vue";
import Component from "vue-class-component";
import Service from "@/api/Services/Service";
import SelectServiceClinicNames from "@/components/Util/SelectServiceClinic/SelectServiceClinic.vue";

import { ServiceInterface } from "@/api/Interfaces/ServiceInterface";
import { busHome } from "@/views/Home/HomeBus";
import { ResponseInterface } from "@/api/Interfaces/ResponseInterface";

const ClinicProps = Vue.extend({
  props: {
    imgHome: {
      type: String,
      required: false,
    },
    imgLogo: {
      type: String,
      required: false,
    },
    service: {
      type: [Object as () => ServiceInterface],
      default: null,
    },
  },
});

@Component<Clinic>({
  name: "Clinic",

  components: {
    "select-service-clinic-names": SelectServiceClinicNames,
  },

  computed: {
    canSearchServices: function () {
      return !!this.cx_selectedServiceClinicName;
    },
    cx_zipCodeSearchCheck: {
      get(): boolean {
        return this.$store.state.globalSearch.getZipCodeSearchCheck;
      },
      set(value: boolean): void {
        if (value) {
          this.cx_zipCodeIsVisible = true;
          this.cx_checkboxZipCodeIsActive = "text_checkbox_active";
        } else {
          this.cx_zipCodeIsVisible = false;
          this.cx_checkboxZipCodeIsActive = "";
        }
        this.$store.commit("setZipCodeSearchCheck", value);
      },
    },
  },
})
export default class Clinic extends ClinicProps {
  cx_Services = new Service();
  cx_service = this.service;
  cx_home = this.imgHome;
  cx_clinic = this.imgLogo;
  cx_zipCode!: string;
  cx_zipCodeCheckBox!: boolean;
  cx_zipCodeIsVisible!: boolean;
  cx_checkboxZipCodeIsActive!: string;
  cx_directSearch!: boolean;

  cx_selectedServiceClinicNames!: Service;
  cx_serviceCategories!: Array<Service>;
  cx_selectedServiceClinicName!: any;
  cx_buttonActive!: string;
  clinicId!: string;

  constructor() {
    super();

    this.cx_zipCode = "";
    this.cx_zipCodeCheckBox = false;
    this.cx_zipCodeIsVisible = false;
    this.cx_checkboxZipCodeIsActive = "";
    this.cx_directSearch = false;
    this.cx_selectedServiceClinicNames = new Service();
    this.cx_selectedServiceClinicName = null;
    this.cx_serviceCategories = [] as Array<Service>;
    this.cx_buttonActive = "";
    this.clinicId = "";
  }

  mounted(): void {
    this.cx_service = this.service;
    this.cx_home = this.imgHome;
    this.cx_clinic = this.imgLogo;
    this.cx_zipCode = "";
    this.cx_zipCodeCheckBox = false;
    this.cx_zipCodeIsVisible = false;
    this.cx_checkboxZipCodeIsActive = "";
    this.cx_serviceCategories = [] as Array<Service>;
    this.cx_selectedServiceClinicName = null;
    this.cx_buttonActive = "";
    this.clinicId = this.getCLinicId();
    this.searchServiceDefaultNames();

    busHome.$on("searchServiceDefaultNameByCode", this.searchServiceDefaultNameByCode);
  }

  getCLinicId() {
    return this.$route.name == "ClinicScreen" ? this.$route.params.clinicId : "";
  }

  searchServiceDefaultNames(): void {
    this.cx_Services
      .listServices(this.clinicId)
      .then((response) => {
        const responseData = response.data as ResponseInterface;
        response.data.length ? (this.cx_buttonActive = "btnIsActive") : (this.cx_buttonActive = "");
        this.cx_serviceCategories = response.data.data;
      })
      .catch((error) => {
        console.error(error);
      });
  }

  changeServiceClinicName(selectedServiceClinicName: Service): void {
    this.cx_selectedServiceClinicName = selectedServiceClinicName;
  }

  setErrorPage(): void {
    if (this.$route.name !== "SearchError") this.$router.push({ name: "SearchError" });
  }

  searchServiceDefaultNameByCode(code: string): void {
    this.cx_selectedServiceClinicName = this.cx_serviceCategories.find((el: any) => {
      return el.code == code;
    });

    if (!this.cx_zipCode) {
      this.cx_directSearch = true;
    } else {
      this.cx_directSearch = false;
    }
  }
}
